import store from '@/store'
export const setCard = (data = {}) => {
  let list = new Array(4).fill(null)
  list[0] = {
    title: $t('storage::stock-analysis::suggest_purchase'),
    suffix: 'SPU',
    prefix: data.suggestPurchase,
    tooltip: $t('storage::stock-analysis::purchase_tips', { day: data.purchaseDays }),
    preTooltip: $t('storage::stock-analysis::purchase_click'),
    type: 1,
  }
  // list[1] = {
  //   title: $t('storage::stock-analysis::purchase_unfinished'),
  //   suffix: $t('storage::stock-analysis::order'),
  //   prefix: data.unfinishPurchase,
  //   tooltip: $t('storage::stock-analysis::purchase_unfinished_tips'),
  //   preTooltip: $t('storage::stock-analysis::purchase_unfinished_click'),
  //   type: 2,
  // }
  list[1] = {
    title: $t('storage::stock-analysis::sales_rise'),
    suffix: 'SPU',
    prefix: data.salesUp,
    tooltip: $t('storage::stock-analysis::sales_rise_tips', { day: data.salesUpCycle, percentage: data.salesUpRate }),
    preTooltip: $t('storage::stock-analysis::sales_rise_click'),
    type: 3
  }
  list[2] = {
    title: $t('storage::stock-analysis::sales_down'),
    suffix: 'SPU',
    prefix: data.salesDown,
    tooltip: $t('storage::stock-analysis::sales_down_tips', { day: data.salesDownCycle, percentage: data.salesDownRate }),
    preTooltip: $t('storage::stock-analysis::sales_down_click'),
    type: 4
  }
  list[3] = {
    title: $t('storage::stock-analysis::un_move'),
    suffix: 'SPU',
    prefix: data.salesHard,
    tooltip: $t('storage::stock-analysis::un_move_tips', { day: data.fixPinDays }),
    preTooltip: $t('storage::stock-analysis::un_move_click'),
    type: 5
  }
  if (store.state.user.sourceType === 2) {
    list.splice(1, 0, {
      title: $t('storage::stock-analysis::purchase_unfinished'),
      suffix: $t('storage::stock-analysis::order'),
      prefix: data.unfinishPurchase,
      tooltip: $t('storage::stock-analysis::purchase_unfinished_tips'),
      preTooltip: $t('storage::stock-analysis::purchase_unfinished_click'),
      type: 2,
    })
  }
  return list
}

export const searchConfig = (supplierList, cateList) => {
  return [
    {
      key: ['searchType', 'searchValue'],
      searchType: 'selectInput',
      componentData: {
        defaultValue: ['2', ''],
        options: [
          { label: 'SKU', value: '1' },
          { label: 'SPU', value: '2' },
          { label: $t('ocean-bi:商品名称'), value: '3' },
          { label: $t('storage::stock-analysis::商品类目'), value: '4' }
        ],
      },
    },
    {
      key: 'supplierId',
      searchType: 'select',
      componentData: {
        placeholder: $t('storage::out-stock::supplier_select_holder'),
        options: supplierList,
      },
    },
    {
      key: 'categoryId',
      searchType: 'select',
      componentData: {
        filterable: true,
        placeholder: $t('stores::products-info::select_category'),
        options: cateList,
      },
    },
    // {
    //   key: 'saleDays',
    //   searchType: 'select',
    //   componentData: {
    //     filterable: true,
    //     placeholder: $t('storage::stock-analysis::salesDay_placeholder'),
    //     options: [
    //       { label: $t('storage::stock-analysis::近7天'), value: '7' },
    //       { label: $t('storage::stock-analysis::近30天'), value: '30' },
    //       { label: $t('storage::stock-analysis::近3个月'), value: '90' },
    //       { label: $t('storage::stock-analysis::近6个月'), value: '180' },
    //       { label: $t('storage::stock-analysis::自创建以来'), value: '' },
    //     ],
    //   },
    // },
  ]

}

export const tableColumns = [
  {
    prop: 'expand',
    fixed: true,
    minWidth: 85
  },
  {
    label: $t('storage::stock-analysis::商品信息'),
    minWidth: 300,
    showOverflowTooltip: true,
    tooltipRowKey: 'productName',
    prop: 'prod'
  },
  {
    label: $t('storage::stock-analysis::商品类目'),
    minWidth: 150,
    prop: 'productCategoryName'
  },
  {
    label: $t('storage::stock-analysis::商品库存'),
    prop: 'productStock',
    minWidth: 120
  },
  {
    label: $t('storage::stock-analysis::可用库存'),
    prop: 'usedStock',
    minWidth: 130
  },
  // {
  //   label: $t('storage::stock-analysis::销量合计'),
  //   prop: 'totalQuantity',
  //   minWidth: 130
  // },
  {
    label: $t('storage::stock-analysis::待发货'),
    prop: 'shipWaitNum',
    minWidth: 130
  },
  {
    prop: 'stock',
    slotHeaderName: 'stockHeader',
    minWidth: 200
  },
  {
    label: $t('storage::stock-analysis::销量'),
    prop: 'sale',
    minWidth: 200
  },
  {
    prop: 'day',
    minWidth: 200,
    slotHeaderName: 'dayHeader'
  },
  {
    label: $t('storage::stock-analysis::供应商'),
    prop: 'supplierName',
    minWidth: 130
  },
  {
    label: $t('storage::stock-analysis::成本价'),
    prop: 'supplyCost',
    minWidth: 130
  }
]
